export class SaasProtectionStatusFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<SaasProtectionStatus>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<SaasProtectionStatus>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasProtectionStatusFilters.attributeTypeMap;
    }
    constructor() {
    }
}
